import { findInvalidTelHrefs } from "@/utility/validateTelHref";
import { traverseTree } from "@/utility/traverseTree";

const HTML_FIELDS = ["content", "text", "value"];

export function findInvalidTelHrefsDeep(obj) {
  const errors = [];
  walk(obj, errors);
  return { valid: errors.length === 0, errors };
}

// Marks nodes with `_telHrefError` for visual error highlighting in tree
export function syncTelHrefErrors(messages, vm) {
  traverseTree(messages, node => {
    const hasError = HTML_FIELDS.some(
      field => typeof node[field] === "string" && findInvalidTelHrefs(node[field]).length > 0,
    );
    if (hasError) {
      vm.$set(node, "_telHrefError", true);
    } else if (node._telHrefError !== undefined) {
      vm.$delete(node, "_telHrefError");
    }
  });
}


function walk(obj, errors) {
  if (obj == null || typeof obj !== "object") return;

  if (Array.isArray(obj)) {
    obj.forEach(item => walk(item, errors));
    return;
  }

  for (const key of Object.keys(obj)) {
    const value = obj[key];

    if (HTML_FIELDS.includes(key) && typeof value === "string") {
      const invalidHrefs = findInvalidTelHrefs(value);
      if (invalidHrefs.length > 0) {
        errors.push({ node: obj, field: key, invalidHrefs });
      }
    } else if (typeof value === "object" && value !== null) {
      walk(value, errors);
    }
  }
}
